import { isValidPhoneNumber } from 'react-phone-number-input';
import * as Yup from 'yup';

export interface FormValues {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber?: string;
  references?: string;
  isAgreedToPrivacyPolicy: boolean;
  isSubscribedToNewsletter?: boolean;
}

export const initialValues: FormValues = {
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: '',
  references: '',
  isAgreedToPrivacyPolicy: false,
  isSubscribedToNewsletter: true,
};

export const isPhoneNumberValid = (value: string | undefined) => {
  if (value) {
    return isValidPhoneNumber(value);
  }
  return true;
};

export const getValidationSchema = (t) =>
  Yup.object().shape({
    firstName: Yup.string().required(t('miniWebSite.booking.validations.firstName')),
    lastName: Yup.string().required(t('miniWebSite.booking.validations.lastName')),
    email: Yup.string()
      .email(t('miniWebSite.booking.validations.emailInvalid'))
      .required(t('miniWebSite.booking.validations.emailRequired')),
    phoneNumber: Yup.string().test(
      'phoneNumber',
      t('miniWebSite.booking.validations.phoneNumberInvalid'),
      isPhoneNumberValid
    ),
    references: Yup.string(),
    isAgreedToPrivacyPolicy: Yup.boolean().oneOf(
      [true],
      t('miniWebSite.booking.validations.agree')
    ),
    isSubscribedToNewsletter: Yup.boolean(),
  });
